import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import axios from "axios";

import { styled, Box, CardMedia, Typography } from '@mui/material';

const PREFIX = 'SmartImage';

const classes = {
    root: `${PREFIX}-root`,
    linearProgress: `${PREFIX}-linearProgress`,
    mediaContainer: `${PREFIX}-mediaContainer`,
    media: `${PREFIX}-media`,
    mediaLoading: `${PREFIX}-mediaLoading`,
    loadingContainer: `${PREFIX}-loadingContainer`
};

const StyledBox = styled(Box)((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        height: '100%',
		backgroundColor: theme.palette.background.default
    },

    [`& .${classes.linearProgress}`]: {
        height: '1px'
    },

    [`& .${classes.mediaContainer}`]: {
        height: '100%',
        width: '100%',
        display: 'block',
    },

    [`& .${classes.media}`]: {
        height: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
    },

    [`& .${classes.mediaLoading}`]: {
        position: 'relative',
        width: '100%',
        height: '100',
    },

    [`& .${classes.loadingContainer}`]: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '0px'
    }
}));

export default function SmartImage({id, containerHeight, configuration}) {


    const config = useSelector(state => state.config);
    const auth = useSelector(state => state.auth);
    const data = useSelector(state => state.data);

    // hhttps://jacobsengineering.sharepoint.com/sites/CPOV012053/HomeLib/Forms/HomeLib.aspx

    //     configuration: {
    //          dataSource: {
    //              imageTableName:
    //              imageIDPublished:
    //              imageIDStaged:
    //          },
    //          element: {
    //              size: small | medium | large (assumes SMImage, MDImage, LGImage are the field names)
    //              backgroundSize: contain | cover
    //              showFetching: true | false
    //          }
    //      }

    // DataSource
    const imageTableName = configuration.dataSource.imageTableName;
    const imageIDPublished = configuration.dataSource.imageIDPublished;
    const imageIDStaged = configuration.dataSource.imageIDStaged;
    // Element
    const imageSize = configuration.element.size;
    const imageBackgroundSize = configuration.element.backgroundSize;

    // App State

    // Component State
    const [image, setImage] = useState(null);
    const [imageLoading, setImageLoading] = useState(true);
    // const [showProgress, setShowProgress] = useState(configuration.element.showFetching !== undefined ? configuration.element.showFetching : true);

    // Data
    useEffect(() => {

        // Get image parameters from config for axios call
        let imageParams = getImageParameters(imageSize);

        const url = config.data.authentication.api + 'DBQuery';

        axios.get(url, {
            params: {
                db: config.data.authentication.apiSource,
                table: '{0}{1}'.format(imageTableName, data.viewStaged ? 'Staged': ''),
                fields: imageParams.targetFieldName,
                where: '{0} eq {1}'.format(data.viewStaged ? imageIDStaged : imageIDPublished, 1) // TODO: config
                // where: '{0} eq {1}'.format(data.viewStaged ? imageIDStaged : imageIDPublished, carouselItem.identifier)
            },
            useCache: true
        })
            .then(function (response) {
                // console.log('-----> SmartCarouselItem:useEffect(): Response: ', response);
                const imageBase64 = 'data:image/png;base64,' + response.data[0][imageParams.responseName];
                setImage(imageBase64);
            })
            .catch(function (error) {
                // console.log('-----> SmartCarouselItem:useEffect(): Error: ', error);
                // setImage(NoImage);
            });

    }, []);

    // useEffect(() => {
    //
    //     setViewStaged(staged);
    //
    // }, [staged]);

    useEffect(() => {

        if (image) {
            setImageLoading(false);
        } else {
            setImageLoading(true);
        }
    }, [image]);

    const getImageParameters = (value) => {
        // console.log('-----> SmartImage:getImageParameters()');

        let targetFieldName = '';
        let responseName = '';

        switch(value.toLowerCase()) {
            case 'small':
                targetFieldName = 'SMImage';
                responseName = 'smImage';
                break;
            case 'medium':
                targetFieldName = 'MDImage';
                responseName = 'mdImage';
                break;
            case 'large':
                targetFieldName = 'LGImage';
                responseName = 'lgImage';
                break;
            default:
                targetFieldName = 'MDImage';
                responseName = 'mdImage';
        }

        const imageParams = {
            targetFieldName: targetFieldName,
            responseName: responseName
        }

        // console.log('-----> SmartImage:getImageParameters(): imageParams', imageParams);
        return imageParams;
    }

    return (
        // <Box style={{height: containerHeight}}>
        <StyledBox className={classes.root}>
            {imageLoading &&
            <div className={classes.loadingContainer}>
                <Typography variant="subtitle2" gutterBottom style={{textAlign: 'center'}}>
                    LOADING...
                </Typography>
            </div>
            }
            {!imageLoading &&
            <Box className={classes.mediaContainer}>
                <CardMedia className={classes.media} style={{backgroundSize: imageBackgroundSize}} image={image}/>
            </Box>
            }
        </StyledBox>
    );
}
